export const CommunityIcon = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.33342 15L7.46675 12.6667H4.00008C3.63189 12.6667 3.33341 12.3682 3.33341 12V4.73508C3.33341 4.36689 3.63189 4.06841 4.00008 4.06841H14.6667C15.0349 4.06841 15.3334 4.36689 15.3334 4.73508V12C15.3334 12.3682 15.0349 12.6667 14.6667 12.6667H11.2001L9.33342 15ZM10.5592 11.3334H14.0001V5.40175H4.66675V11.3334H7.46675H8.10761L9.33342 12.8656L10.5592 11.3334ZM1.33341 1.33337H12.6667V2.66671H2.00008V10H0.666748V2.00004C0.666748 1.63185 0.965228 1.33337 1.33341 1.33337Z"
        fill="currentColor"
      />
    </svg>
  );
};
